/* eslint-disable */
var icon = require('vue-svgicon')
icon.register({
  'info': {
    width: 16,
    height: 16,
    viewBox: '0 0 256 256',
    data: '<path pid="0" d="M130 241c-58.5 0-106-47.5-106-106S71.5 29 130 29s106 47.5 106 106-47.5 106-106 106zm0-190.8c-46.8 0-84.8 38-84.8 84.8s38 84.8 84.8 84.8 84.8-38 84.8-84.8-38-84.8-84.8-84.8z"/><path pid="1" d="M140.6 166.8v-42.4c0-5.8-4.7-10.6-10.6-10.6h-21.2V135h10.6v31.8H98.2V188h63.6v-21.2h-21.2z"/><circle pid="2" cx="130" cy="92.6" r="13.3"/>'
  }
})
